import React, { useEffect, useState } from "react";
import styled from "styled-components";
import AppBar from "../../components/AppBar";
import ToolBarLogin from "../../components/ToolBarLogin";
import { Link } from "react-router-dom";

import MenuIcon from "../../images/menuIcon.png";
import Globais, {
  logout,
  validateToken,
  validateTokenEmail,
} from "../../components/Globais";
import axios from "axios";
import logo from "../../images/logo.png";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import PersonAdd from "@mui/icons-material/PersonAdd";
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";

const ContainerHeader = styled.header`
  position: sticky;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background-color: ${Globais.CorVerde};

  align-items: center;
  justify-content: center;
  display: grid;
  grid-template: 100% / 30% 1fr 30% 10%;
`;

const Container = styled.div`
  // background-color: ${Globais.CorVerde};
  // border: 2px solid black;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-end;

  @media (min-width: 1200px) {
    max-width: 1140px;
  }
  @media (min-width: 992px and max-width: 1199px) {
    max-width: 960px;
  }
  @media (min-width: 768px and max-width: 991px) {
    max-width: 720px;
  }
  @media (min-width: 576px and max-width: 767px) {
    max-width: 540px;
  }
  @media (min-width: 700px) {
    grid-template: 100% / 30% 1fr;
  }
  @media (max-width: 500px) {
    grid-column-start: 3;
  }
`;

const Icon = styled.img`
  width: 100%;
  height: 100%;
`;
const ContainerInfo = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template: 100% / 1fr 1fr;
`;

const ContainerMenu = styled.button`
  display: flex;
  cursor: pointer;
  background-color: transparent;
  border: none;
  width: 3rem;
  height: 2.5rem;
  margin-top: 2.3rem;
  margin-left: 1.5rem;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;

  @media (max-width: 500px) {
    margin-left: 3rem;
  }

  @media (min-width: 1000px) {
    width: 3rem;
    height: 2.5rem;
    margin-top: 2.3rem;
    margin-left: 2rem;
  }
`;
const ContainerBoasVindas = styled.div`
  display: none;
  @media (min-width: 700px) {
    display: flex;

    width: 100%;
  }
`;
const ImagemLogo = styled.img`
  width: 100%;
  height: 100%;
  max-width: 200px;

  @media (max-width: 500px) {
    max-height: 7rem;
    margin-top: 1rem;
  }
`;

const H3BoasVindas = styled.h3`
  color: #fff;
  text-align: center;
  align-self: center;
  font-size: 2.5rem;

  // @media (min-width: 600px) and (max-width: 699px) {
  //   font-size: 1rem;
  // }
  // @media (min-width: 700px) and (max-width: 999px) {
  //   font-size: 1.5rem;
  // }

  @media (min-width: 700px) {
    font-size: 2rem;
  }
`;
const ContainerEntrar = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  a:link {
    text-decoration: none;
  }
`;

const TextoEntrar = styled.h4`
  color: #fff;
  text-align: center;
  margin-left: 0.5rem;
  @media (min-width: 700px) {
    font-size: 1rem;
  }
`;

const ContainerContaMenu = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
`;

//Essa view foi criada para os casos em que pelo e-mail usuario acessa sistema. No modelo anterior o view app bar tentava acessar o token e fazia logout. Nesse o validateToken é diferente
export default function ViewAppBarEmail() {
  const [isMenuVisible, setIsMenuVisible] = useState(false);

  const [usuario, setUsuario] = useState<any | null>(null);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    const fetchToken = async () => {
      const Token = validateTokenEmail();

      if (Token) {
        const URL = `${Globais.DOMINIOBACK}/usuario/${Token.id}`;
        ////
        try {
          const response = await axios.get(URL, {
            headers: { Authorization: Token.AuthStr },
          });
          if (response) {
            setUsuario(response.data);
          }
        } catch (error) {
          console.log(error);
        }
      }
    };

    fetchToken();
  }, []);
  return (
    <ContainerHeader>
      <ContainerInfo>
        <ContainerMenu
          onClick={() => {
            isMenuVisible ? setIsMenuVisible(false) : setIsMenuVisible(true);
          }}
        >
          <Icon src={MenuIcon} alt="menu" />
        </ContainerMenu>
        {isMenuVisible ? (
          usuario ? (
            <ToolBarLogin props={usuario.nda} />
          ) : (
            <ToolBarLogin props={"9"} />
          )
        ) : null}
        <ContainerBoasVindas>
          {usuario ? (
            <H3BoasVindas>
              Olá <br />
              {usuario.nome}
            </H3BoasVindas>
          ) : (
            <ContainerEntrar>
              <Link to="/login">
                <TextoEntrar>ENTRAR</TextoEntrar>
              </Link>
            </ContainerEntrar>
          )}
        </ContainerBoasVindas>
      </ContainerInfo>
      <AppBar />
      <Container>
        <a href="/">
          <ImagemLogo src={logo} />
        </a>
      </Container>
      <div></div>
    </ContainerHeader>
  );
}
